import script from "./TabBar.vue?vue&type=script&setup=true&lang=ts&name=TabBar"
export * from "./TabBar.vue?vue&type=script&setup=true&lang=ts&name=TabBar"

import "./TabBar.vue?vue&type=style&index=0&id=1b8e870e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b8e870e"]])

export default __exports__